<script lang="ts">
	import Image from '$lib/components/atoms/image/Image.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';

	export let text: string;
	export let redirectUrl: string;
	export let label: string;
	export let imageScr: string;
	export let imageAlt: string;
</script>

<div class="p-4 bg-neutral-weakest rd-4 text-center">
	<Image
		src={imageScr}
		alt={imageAlt}
		objectFit="contain"
		class="mb-2 h-25 w-25"
	/>
	<div class="mt-0.5 mb-3 text-center text-sm">{text}</div>
	{#if redirectUrl}
		<div class="flex justify-center">
			<Link
				button="filled"
				href={redirectUrl}
				icon="open-in-new"
				{label}
				target="_blank"
				rel="external"
			/>
		</div>
	{/if}
</div>
